"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lines_1 = require("../lines");
var PurchaseOrderLineResource = /** @class */ (function (_super) {
    tslib_1.__extends(PurchaseOrderLineResource, _super);
    function PurchaseOrderLineResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PurchaseOrderLineResource.prototype.getRelievingLines = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.wrap('/relieving')
                        .get()
                        .then(function (result) {
                        return result.data;
                    })];
            });
        });
    };
    PurchaseOrderLineResource.endpoint = '/lines/po';
    PurchaseOrderLineResource.MODEL_NAME = 'purchaseorderline';
    return PurchaseOrderLineResource;
}(lines_1.BaseLineResource));
exports.default = PurchaseOrderLineResource;
//# sourceMappingURL=lines.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/po/lines.js
// module id = 1mAF
// module chunks = 0